import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22ac9c5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company" }
const _hoisted_2 = { class: "company-header" }
const _hoisted_3 = { class: "company-title" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_7 = { class: "section-bar" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Mitarbeiter:innen", -1))
const _hoisted_9 = { class: "section-actions" }
const _hoisted_10 = {
  class: "btn-ghost",
  "data-bs-toggle": "modal",
  "data-bs-target": "#inviteUser"
}
const _hoisted_11 = { class: "table-wrap" }
const _hoisted_12 = { class: "data-table" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Vorname", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nachname", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "E-Mail", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Gruppen", -1))
const _hoisted_17 = { class: "th-help" }
const _hoisted_18 = { class: "th-tip" }
const _hoisted_19 = {
  type: "button",
  class: "th-tip-trigger",
  "aria-label": "Hinweis zu den Aufgaben"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "th-tip-bubble",
  role: "tooltip"
}, " Alle Aufgaben dieses Mitarbeiters: direkt zugewiesene Kurse und Unterweisungen sowie Aufgaben aus Gruppen, in denen er Mitglied ist. ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Aktionen", -1))
const _hoisted_22 = { class: "user-name" }
const _hoisted_23 = {
  key: 0,
  class: "badge badge-owner user-role-badge"
}
const _hoisted_24 = { class: "user-name" }
const _hoisted_25 = { class: "user-email" }
const _hoisted_26 = { class: "user-group-chips" }
const _hoisted_27 = ["title", "onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chip-x" }, "×", -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "assignment-chips assignment-chips--row" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = { style: {"display":"inline-flex","gap":"4px"} }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty-state"
}, "Noch keine Mitarbeiter angelegt.", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty-state"
}, "Keine Mitarbeiter gefunden.", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_44 = { class: "section-bar" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Gruppen", -1))
const _hoisted_46 = { class: "section-actions" }
const _hoisted_47 = { class: "group-tree" }
const _hoisted_48 = {
  key: 0,
  class: "empty-state",
  style: {"padding":"32px 0"}
}
const _hoisted_49 = {
  key: 1,
  class: "group-drag-error"
}
const _hoisted_50 = { class: "group-card" }
const _hoisted_51 = {
  class: "group-row",
  title: "Zum Sortieren ziehen"
}
const _hoisted_52 = { class: "group-info" }
const _hoisted_53 = { class: "group-name" }
const _hoisted_54 = { class: "group-chip-row" }
const _hoisted_55 = { class: "group-course-chips" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "group-member-chips" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "group-actions" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "group-child-item" }
const _hoisted_63 = {
  class: "group-row child-row",
  title: "Zum Sortieren ziehen"
}
const _hoisted_64 = { class: "group-info" }
const _hoisted_65 = { class: "group-name" }
const _hoisted_66 = { class: "group-chip-row" }
const _hoisted_67 = { class: "group-course-chips" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = { class: "group-member-chips" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "group-actions" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "group-child-item" }
const _hoisted_75 = {
  class: "group-row child-row",
  title: "Zum Sortieren ziehen"
}
const _hoisted_76 = { class: "group-info" }
const _hoisted_77 = { class: "group-name" }
const _hoisted_78 = { class: "group-chip-row" }
const _hoisted_79 = { class: "group-course-chips" }
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "group-member-chips" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "group-actions" }
const _hoisted_84 = ["onClick"]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "group-modal" }
const _hoisted_87 = { class: "group-modal-title" }
const _hoisted_88 = ["onKeyup"]
const _hoisted_89 = {
  key: 0,
  class: "group-weight-field"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-weight-label" }, "Sortierung (Gewicht)", -1))
const _hoisted_91 = ["onKeyup"]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "group-weight-hint" }, "Kleinere Werte stehen weiter oben. Die Reihenfolge lässt sich auch per Ziehen ändern.", -1))
const _hoisted_93 = {
  key: 1,
  class: "group-modal-error"
}
const _hoisted_94 = { class: "group-modal-footer" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = ["onClick"]
const _hoisted_97 = { class: "group-modal assign-modal" }
const _hoisted_98 = { class: "group-modal-header" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-modal-title" }, "Mitarbeiter zuordnen", -1))
const _hoisted_100 = { class: "assign-modal-group-name" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "assign-modal-hint" }, "Änderungen werden sofort gespeichert.", -1))
const _hoisted_102 = { class: "assign-user-list" }
const _hoisted_103 = {
  key: 0,
  class: "assign-loading"
}
const _hoisted_104 = ["checked", "onChange"]
const _hoisted_105 = { class: "assign-user-info" }
const _hoisted_106 = { class: "assign-user-name" }
const _hoisted_107 = {
  key: 0,
  class: "assign-user-email"
}
const _hoisted_108 = {
  key: 0,
  class: "assign-empty"
}
const _hoisted_109 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-bar" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Freigegebene Kurse")
], -1))
const _hoisted_111 = {
  key: 0,
  class: "empty-state",
  style: {"padding":"48px 0"}
}
const _hoisted_112 = {
  key: 1,
  class: "table-wrap"
}
const _hoisted_113 = { class: "data-table" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Titel"),
    /*#__PURE__*/_createElementVNode("th", null, "Kategorie"),
    /*#__PURE__*/_createElementVNode("th", null, "Dauer"),
    /*#__PURE__*/_createElementVNode("th", null, "Zuweisungen"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Aktionen")
  ])
], -1))
const _hoisted_115 = { class: "user-name" }
const _hoisted_116 = {
  key: 0,
  class: "user-email"
}
const _hoisted_117 = {
  key: 0,
  class: "badge badge-member"
}
const _hoisted_118 = {
  key: 1,
  class: "badge badge-member"
}
const _hoisted_119 = { class: "assignment-chips" }
const _hoisted_120 = ["onClick"]
const _hoisted_121 = {
  key: 1,
  class: "muted-text"
}
const _hoisted_122 = { class: "text-end" }
const _hoisted_123 = ["onClick"]
const _hoisted_124 = { key: 0 }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "empty-state"
}, "Für diese Einrichtung sind noch keine Kurse freigegeben.", -1))
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = { class: "group-modal list-popup" }
const _hoisted_128 = { class: "group-modal-title" }
const _hoisted_129 = { class: "list-popup-items" }
const _hoisted_130 = ["onClick"]
const _hoisted_131 = { class: "lp-text" }
const _hoisted_132 = { class: "lp-label" }
const _hoisted_133 = {
  key: 0,
  class: "lp-sub"
}
const _hoisted_134 = ["onClick"]
const _hoisted_135 = {
  key: 0,
  class: "lp-empty"
}
const _hoisted_136 = { class: "group-modal-footer" }
const _hoisted_137 = { class: "group-modal assignment-modal" }
const _hoisted_138 = { class: "group-modal-title" }
const _hoisted_139 = {
  key: 0,
  class: "field-block"
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Art", -1))
const _hoisted_141 = { class: "toggle-group" }
const _hoisted_142 = {
  key: 0,
  class: "field-block"
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, [
  /*#__PURE__*/_createTextVNode("Unterweisung "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Bitte wählen…", -1))
const _hoisted_145 = ["value"]
const _hoisted_146 = {
  key: 1,
  class: "assign-modal-subtitle"
}
const _hoisted_147 = {
  key: 0,
  class: "field-block"
}
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, [
  /*#__PURE__*/_createTextVNode("Kurs "),
  /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*")
], -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Bitte wählen…", -1))
const _hoisted_150 = ["value"]
const _hoisted_151 = {
  key: 1,
  class: "assign-modal-subtitle"
}
const _hoisted_152 = { class: "field-block" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Zuweisen an", -1))
const _hoisted_154 = { class: "toggle-group" }
const _hoisted_155 = { class: "field-block" }
const _hoisted_156 = { class: "field-label" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "req" }, "*", -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Bitte wählen…", -1))
const _hoisted_159 = ["value"]
const _hoisted_160 = ["value"]
const _hoisted_161 = { class: "field-block" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Frist (optional)", -1))
const _hoisted_163 = { class: "field-block field-inline" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Jährlich wiederholen", -1))
const _hoisted_165 = { class: "field-block" }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Start der Erinnerungsphase", -1))
const _hoisted_167 = { class: "notify-input-row" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notify-unit" }, "Tage vor Frist", -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "Ab wann beginnt die Erinnerungsphase.", -1))
const _hoisted_170 = { class: "field-block" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Anzahl Erinnerungen", -1))
const _hoisted_172 = { class: "notify-input-row" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "Wie oft wird innerhalb der Phase erinnert (gleichmäßig verteilt bis zur Frist).", -1))
const _hoisted_174 = {
  key: 4,
  class: "group-modal-error"
}
const _hoisted_175 = { class: "group-modal-footer" }
const _hoisted_176 = ["disabled"]
const _hoisted_177 = {
  key: 5,
  class: "tab-content"
}
const _hoisted_178 = {
  key: 6,
  class: "tab-content"
}
const _hoisted_179 = { class: "section-bar" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Abschlüsse", -1))
const _hoisted_181 = { class: "section-actions" }
const _hoisted_182 = { class: "table-wrap" }
const _hoisted_183 = { class: "data-table" }
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Mitarbeiter:in"),
    /*#__PURE__*/_createElementVNode("th", null, "Kurse"),
    /*#__PURE__*/_createElementVNode("th", null, "Unterweisungen"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-end" }, "Zertifikat")
  ])
], -1))
const _hoisted_185 = { class: "user-name" }
const _hoisted_186 = { class: "user-email" }
const _hoisted_187 = ["onClick"]
const _hoisted_188 = {
  key: 1,
  class: "muted-text"
}
const _hoisted_189 = ["onClick"]
const _hoisted_190 = {
  key: 1,
  class: "muted-text"
}
const _hoisted_191 = { class: "text-end" }
const _hoisted_192 = ["disabled", "onClick"]
const _hoisted_193 = { key: 0 }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "4",
  class: "empty-state"
}, "Keine Daten vorhanden.", -1))
const _hoisted_195 = [
  _hoisted_194
]
const _hoisted_196 = {
  key: 7,
  class: "tab-content"
}
const _hoisted_197 = { class: "section-bar" }
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Erinnerungen", -1))
const _hoisted_199 = { class: "section-actions" }
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ALL" }, "Alle Status", -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "QUEUED" }, "Übermittelt", -1))
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "DELIVERED" }, "Zugestellt", -1))
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "FAILED" }, "Fehlgeschlagen", -1))
const _hoisted_204 = [
  _hoisted_200,
  _hoisted_201,
  _hoisted_202,
  _hoisted_203
]
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "reminder-hint" }, " Übersicht aller automatisch versendeten Erinnerungen an Mitarbeitende mit offenen Pflicht-Fortbildungen oder Unterweisungen: wann und an wen sie verschickt wurden. ", -1))
const _hoisted_206 = { class: "table-wrap table-scroll" }
const _hoisted_207 = { class: "data-table" }
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Übermittelt am"),
    /*#__PURE__*/_createElementVNode("th", null, "Empfänger:in"),
    /*#__PURE__*/_createElementVNode("th", null, "Art"),
    /*#__PURE__*/_createElementVNode("th", null, "Kurs / Unterweisung"),
    /*#__PURE__*/_createElementVNode("th", null, "Frist"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1))
const _hoisted_209 = { class: "user-name" }
const _hoisted_210 = { class: "user-email" }
const _hoisted_211 = { key: 0 }
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty-state"
}, "Wird geladen…", -1))
const _hoisted_213 = [
  _hoisted_212
]
const _hoisted_214 = { key: 1 }
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "empty-state"
}, "Es wurden noch keine Erinnerungen versendet.", -1))
const _hoisted_216 = [
  _hoisted_215
]
const _hoisted_217 = {
  key: 8,
  class: "tab-content"
}
const _hoisted_218 = ["onSubmit"]
const _hoisted_219 = { class: "settings-grid" }
const _hoisted_220 = { class: "settings-card full" }
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Name der Einrichtung", -1))
const _hoisted_222 = { class: "settings-card" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Straße", -1))
const _hoisted_224 = { class: "settings-card" }
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Hausnummer", -1))
const _hoisted_226 = { class: "settings-card" }
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Adresszusatz", -1))
const _hoisted_228 = { class: "settings-card" }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Postleitzahl", -1))
const _hoisted_230 = { class: "settings-card" }
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Stadt", -1))
const _hoisted_232 = { class: "settings-card full" }
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "settings-label" }, "Logo", -1))
const _hoisted_234 = { class: "logo-upload-area" }
const _hoisted_235 = { class: "logo-preview-wrap" }
const _hoisted_236 = ["src"]
const _hoisted_237 = {
  key: 1,
  class: "logo-placeholder"
}
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "28",
  height: "28",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "1.5"
  }),
  /*#__PURE__*/_createElementVNode("polyline", { points: "21 15 16 10 5 21" })
], -1))
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Kein Logo", -1))
const _hoisted_240 = [
  _hoisted_238,
  _hoisted_239
]
const _hoisted_241 = { class: "logo-upload-meta" }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "logo-hint" }, "PNG, JPG oder SVG · Empfohlen: mind. 200 × 200 px", -1))
const _hoisted_243 = ["disabled"]
const _hoisted_244 = {
  key: 0,
  class: "logo-error"
}
const _hoisted_245 = { class: "settings-footer" }
const _hoisted_246 = {
  key: 0,
  class: "save-confirm"
}
const _hoisted_247 = ["disabled"]
const _hoisted_248 = { class: "group-modal edit-user-modal" }
const _hoisted_249 = { class: "group-modal-header" }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-modal-title" }, "Mitarbeiter bearbeiten", -1))
const _hoisted_251 = { class: "edit-user-grid" }
const _hoisted_252 = { class: "field-block" }
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Vorname", -1))
const _hoisted_254 = ["onKeyup"]
const _hoisted_255 = { class: "field-block" }
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "Nachname", -1))
const _hoisted_257 = ["onKeyup"]
const _hoisted_258 = { class: "field-block edit-email-field" }
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "field-label" }, "E-Mail-Adresse", -1))
const _hoisted_260 = ["onKeyup"]
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "Die E-Mail-Adresse wird auch für die Anmeldung verwendet.", -1))
const _hoisted_262 = {
  key: 0,
  class: "field-block edit-admin-field"
}
const _hoisted_263 = { class: "edit-admin-label" }
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "edit-admin-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "edit-admin-title" }, "Administrator"),
  /*#__PURE__*/_createElementVNode("span", { class: "edit-admin-hint" }, "Kann Mitarbeiter verwalten, Kurse zuweisen und Einstellungen ändern.")
], -1))
const _hoisted_265 = {
  key: 0,
  class: "group-modal-error"
}
const _hoisted_266 = { class: "group-modal-footer" }
const _hoisted_267 = ["disabled"]
const _hoisted_268 = { class: "group-modal" }
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-modal-title" }, "Aus Gruppe entfernen?", -1))
const _hoisted_270 = { class: "confirm-text" }
const _hoisted_271 = { class: "group-modal-footer" }

import { ref, computed, watch, onMounted } from 'vue';
import { useStore } from '@/store';
import {
  CheckCircleIcon,
  UserPlusIcon,
  TrashIcon,
  PlusIcon,
  Edit2Icon,
  XIcon,
  InfoIcon,
  BookOpenIcon,
} from '@zhuowenli/vue-feather-icons';
import draggable from 'vuedraggable';
import InviteUser from './modal/InviteUser.vue';
import DeleteUser from './modal/DeleteUser.vue';
import InstructionAdmin from '@/components/InstructionAdmin.vue';
import { getAllByOrganisation } from '@training24/course/src/activity';
import { index as getProfiles } from '@training24/user/src/profilePermissions';
import { adminUpdateProfile } from '@training24/user/src/admin';
import { uploadLogo } from '@training24/organisation/src/logo';
import {
  getGroups,
  createGroup,
  updateGroup as updateGroupApi,
  deleteGroup,
  addUserToGroup,
  removeUserFromGroup,
  type Group,
} from '@training24/organisation/src/group';
import { update as updatePermission } from '@training24/organisation/src/permission';
import { displayPDFByUser } from '../utils/getPDFByUser';
import { displayPDFByOrg } from '../utils/getPDFByOrg';
import { printCertificate, printOrgOverview, type CertItem } from '../utils/printCertificate';

type ListPopupEntry = { label: string; sub?: string; onClick?: () => void; onRemove?: () => void };
type ListPopupAdd = { label: string; action: () => void } | null;
type GroupNode = Group & { weight?: number };

export default /*#__PURE__*/_defineComponent({
  __name: 'Company',
  setup(__props) {

const store = useStore();

// ── Kurskatalog reaktiv laden sobald OrgId verfügbar ist ──
// onMounted läuft oft vor dem Organisation-Store → hier per watch nachholen
const _orgIdForCatalog = computed(() => store.getters['organisation/getOrganisationId']);
watch(_orgIdForCatalog, (orgId) => {
  if (orgId) {
    store.dispatch('lmsCourse/LOAD_CATALOG');
    store.dispatch('courseAssignment/LOAD_ALL', orgId);
    store.dispatch('instruction/LOAD_ALL', { force: true });
  }
}, { immediate: true });

// ── Tabs ──────────────────────────────────────────────────
const isAdmin = computed<boolean>(() => store.getters['permission/isAdmin']);

// Der Erinnerungs-Reiter ist nur für die Verwaltung (OWNER/ADMIN) sichtbar.
const tabs = computed(() => {
  const list = [
    { id: 'users',        label: 'Mitarbeiter' },
    { id: 'groups',       label: 'Gruppen' },
    { id: 'catalog',      label: 'Kurse' },
    { id: 'instructions', label: 'Unterweisungen' },
    { id: 'courses',      label: 'Aktivitäten' },
  ];
  if (isAdmin.value) list.push({ id: 'reminders', label: 'Erinnerungen' });
  list.push({ id: 'settings', label: 'Einstellungen' });
  return list;
});
const activeTab = ref<string>('users');

// Erinnerungs-Log erst beim Öffnen des Reiters laden.
watch(activeTab, (tab) => {
  if (tab === 'reminders') {
    const orgId = store.getters['organisation/getOrganisationId'];
    if (orgId) store.dispatch('reminderLog/LOAD_ALL', { orgId });
  }
});

// ── Erinnerungen (Admin-Log) ──────────────────────────────
const reminderSearch = ref('');
const reminderStatusFilter = ref<'ALL' | 'QUEUED' | 'DELIVERED' | 'FAILED'>('ALL');
const reminderLogs = computed<any[]>(() => store.getters['reminderLog/getAll']);
const reminderLogsLoading = computed<boolean>(() => store.getters['reminderLog/isLoading']);

const filteredReminderLogs = computed<any[]>(() => {
  const q = reminderSearch.value.trim().toLowerCase();
  return reminderLogs.value.filter((r: any) => {
    if (reminderStatusFilter.value !== 'ALL' && normReminderStatus(r.status) !== reminderStatusFilter.value) return false;
    if (!q) return true;
    return [r.userName, r.email, r.itemTitle].some((v: string) => (v || '').toLowerCase().includes(q));
  });
});

function fmtDateTime(ts: number): string {
  if (!ts) return '';
  const d = new Date(ts);
  return d.toLocaleDateString('de-DE') + ' ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}
function fmtIsoDate(iso: string): string {
  if (!iso) return '';
  const p = iso.split('-');
  return p.length === 3 ? `${p[2]}.${p[1]}.${p[0]}` : iso;
}
function reminderKindLabel(kind: string): string {
  return kind === 'INSTRUCTION' ? 'Unterweisung' : 'Kurs';
}
// Alt-Status 'SENT' (vor der Closed-Loop-Bestätigung) wie 'DELIVERED' behandeln.
function normReminderStatus(status: string): string {
  return status === 'SENT' ? 'DELIVERED' : status;
}
function reminderStatusLabel(status: string): string {
  if (status === 'FAILED') return 'Fehlgeschlagen';
  if (status === 'QUEUED') return 'Übermittelt';
  return 'Zugestellt';
}
function reminderBadgeClass(status: string): string {
  if (status === 'FAILED') return 'badge-danger';
  if (status === 'QUEUED') return 'badge-pending';
  return 'badge-success';
}

// ── Store ─────────────────────────────────────────────────
const organisation = computed(() => store.getters['organisation/getOrganisation']);
const users = computed(() => store.getters['permission/getPermissions']);

// ── Mitarbeiter ───────────────────────────────────────────
const selectedUserUserId = ref('');

// Edit user modal
const editUserModalVisible = ref(false);
const editUserTarget = ref<any>(null);
const editUserForm = ref({ firstName: '', lastName: '', email: '', isAdmin: false });
const editUserSaving = ref(false);
const editUserError = ref('');

function openEditUser(user: any) {
  const profile = profiles.value.find((p: any) => p.userId === user.userId);
  editUserForm.value = {
    firstName: profile?.data?.first_name ?? '',
    lastName: profile?.data?.last_name ?? '',
    email: user.email ?? '',
    isAdmin: user.type === 'ADMIN',
  };
  editUserTarget.value = user;
  editUserError.value = '';
  editUserModalVisible.value = true;
}

async function saveEditUser() {
  if (!editUserForm.value.firstName || !editUserForm.value.lastName) {
    editUserError.value = 'Bitte Vor- und Nachname angeben.';
    return;
  }
  const newEmail = editUserForm.value.email.trim();
  if (!newEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)) {
    editUserError.value = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
    return;
  }
  editUserSaving.value = true;
  editUserError.value = '';
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const jwt = store.getters.getJWT;

    await adminUpdateProfile(orgId, editUserTarget.value.userId, {
      first_name: editUserForm.value.firstName,
      last_name: editUserForm.value.lastName,
    }, jwt);

    // Rolle und E-Mail über den Permission-Endpunkt aktualisieren
    const newType = editUserTarget.value.type === 'OWNER'
      ? editUserTarget.value.type
      : (editUserForm.value.isAdmin ? 'ADMIN' : 'VIEWER');
    const roleChanged = newType !== editUserTarget.value.type;
    const emailChanged = newEmail !== (editUserTarget.value.email ?? '');
    if (roleChanged || emailChanged) {
      const payload: any = { type: newType };
      if (emailChanged) payload.email = newEmail;
      await updatePermission(orgId, editUserTarget.value.userId, payload, jwt);
      store.dispatch('permission/LOAD');
    }

    // Profil-Cache aktualisieren
    const idx = profiles.value.findIndex((p: any) => p.userId === editUserTarget.value.userId);
    if (idx >= 0) {
      profiles.value[idx] = {
        ...profiles.value[idx],
        data: { ...profiles.value[idx].data, first_name: editUserForm.value.firstName, last_name: editUserForm.value.lastName },
      };
    }
    editUserModalVisible.value = false;
  } catch (e: any) {
    if (e?.response?.status === 409 && e?.response?.data?.['error-message'] === 'email already in use') {
      editUserError.value = 'Diese E-Mail-Adresse wird bereits verwendet.';
    } else if (e?.response?.status === 409) {
      editUserError.value = 'Dieser Mitarbeiter gehört mehreren Einrichtungen an und kann hier nicht geändert werden.';
    } else {
      editUserError.value = e?.response?.data?.['error-message'] ?? 'Ein Fehler ist aufgetreten.';
    }
  } finally {
    editUserSaving.value = false;
  }
}
const profiles = ref<any[]>([]);

function displayName(user: any): string {
  const profile = profiles.value.find((p: any) => p.userId === user.userId);
  if (profile?.data?.first_name) {
    return `${profile.data.first_name} ${profile.data.last_name}`;
  }
  return user.userName || user.email || '';
}

function userFirstName(user: any): string {
  const profile = profiles.value.find((p: any) => p.userId === user.userId);
  // Ohne Profil-Daten den Benutzernamen als Anhaltspunkt zeigen
  return profile?.data?.first_name || user.userName || '';
}

function userLastName(user: any): string {
  const profile = profiles.value.find((p: any) => p.userId === user.userId);
  return profile?.data?.last_name || '';
}

// ── Suche in der Mitarbeiter-Tabelle ──────────────────────
const userSearch = ref('');

const filteredUsers = computed<any[]>(() => {
  const q = userSearch.value.trim().toLowerCase();
  if (!q) return users.value;
  return (users.value as any[]).filter((u: any) =>
    [userFirstName(u), userLastName(u), u.email || '', u.userName || '']
      .some((v: string) => v.toLowerCase().includes(q))
  );
});

async function loadProfiles() {
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    if (orgId) {
      profiles.value = await getProfiles(orgId, store.getters.getJWT);
    }
  } catch {
    // optional — bei Fehler ohne Profile anzeigen
  }
}

// ── Kurskatalog (freigegebene Kurse) ──────────────────────
const catalogLoading = ref(false);
const catalogCourses = computed(() => store.getters['lmsCourse/getModules']);

// ── Kurszuweisungen ────────────────────────────────────────
const courseAssignModalVisible = ref(false);
const courseAssignModalCourse = ref<any>(null);   // set when opening from catalog tab; null when from group/user tab
const courseAssignModalMode = ref<'create' | 'edit'>('create');
const courseAssignTargetFixed = ref(false);  // true = target (group/user) is pre-selected, hide toggle+dropdown
const editingAssignment = ref<any>(null);
const courseAssignForm = ref({
  kind: 'course' as 'course' | 'instruction',  // Kurs oder Unterweisung
  instructionId: '',                           // used when kind === 'instruction'
  courseId: '',                               // used when opening from group/user tab
  targetType: 'GROUP' as 'GROUP' | 'USER',
  targetId: '',
  deadline: '',
  recurAnnually: false,
  notifyDaysBefore: null as number | null,
  notifyCount: null as number | null,
});

// Alle Unterweisungen (für Dropdown + Titel-Auflösung)
const allInstructions = computed<any[]>(() => store.getters['instruction/getAll'] || []);

function instructionTitle(instructionId: string): string {
  const ins = allInstructions.value.find((i: any) => i.instructionId === instructionId);
  return ins ? ins.title : '';
}

// Kurs-Zuweisungen eines Ziels (kind !== INSTRUCTION; fehlendes kind = Kurs)
function getCourseAssignmentsForTarget(targetType: string, targetId: string): any[] {
  return getAssignmentsForTarget(targetType, targetId).filter((a: any) => a.kind !== 'INSTRUCTION');
}

// Unterweisungs-Zuweisungen eines Ziels (kind === INSTRUCTION)
function getInstructionAssignmentsForTarget(targetType: string, targetId: string): any[] {
  return getAssignmentsForTarget(targetType, targetId).filter((a: any) => a.kind === 'INSTRUCTION');
}

// Chip-Label einer Unterweisungs-Zuweisung
function instructionAssignmentChipLabel(a: any): string {
  const title = instructionTitle(a.instructionId);
  return a.deadline
    ? title + ' (bis ' + new Date(a.deadline).toLocaleDateString('de-DE') + ')'
    : title;
}

// Anzahl aller Zuweisungen (Kurs + Unterweisung) eines Ziels
function assignmentCountForTarget(targetType: string, targetId: string): number {
  return getCourseAssignmentsForTarget(targetType, targetId).length
    + getInstructionAssignmentsForTarget(targetType, targetId).length;
}

// Alle Aufgaben eines Mitarbeiters: direkt zugewiesene plus Aufgaben aus seinen Gruppen
function userTaskCount(user: any): number {
  let count = assignmentCountForTarget('USER', user.userId);
  for (const groupId of (userGroupMemberships.value[user.userId] ?? [])) {
    count += assignmentCountForTarget('GROUP', groupId);
  }
  return count;
}

// ── Listen-Popup (Anzahl-Chip -> Liste) ───────────────────
const listPopup = ref<{ visible: boolean; title: string; entries: ListPopupEntry[]; onAdd: ListPopupAdd }>({
  visible: false,
  title: '',
  entries: [],
  onAdd: null,
});
function openListPopup(title: string, entries: ListPopupEntry[], onAdd: ListPopupAdd = null) {
  listPopup.value = { visible: true, title, entries, onAdd };
}
function fmtDate(iso: string): string {
  return new Date(iso).toLocaleDateString('de-DE');
}

// Zuweisungen (Kurse + Unterweisungen) eines Ziels als Liste mit Hinzufügen/Entfernen
function openAssignmentsPopup(targetType: 'GROUP' | 'USER', targetId: string, label: string) {
  const removeAssignment = async (a: any) => {
    const orgId = store.getters['organisation/getOrganisationId'];
    await store.dispatch('courseAssignment/DELETE', { orgId, assignmentId: a.assignmentId });
    // Liste aus dem aktualisierten Store neu aufbauen
    openAssignmentsPopup(targetType, targetId, label);
  };
  const entries = [
    ...getCourseAssignmentsForTarget(targetType, targetId).map((a: any) => ({
      label: courseTitle(a.courseId),
      sub: a.deadline ? 'Kurs · Frist ' + fmtDate(a.deadline) : 'Kurs',
      onClick: () => { listPopup.value.visible = false; openEditAssignmentFromTarget(a); },
      onRemove: () => removeAssignment(a),
    })),
    ...getInstructionAssignmentsForTarget(targetType, targetId).map((a: any) => ({
      label: instructionTitle(a.instructionId),
      sub: a.deadline ? 'Unterweisung · Frist ' + fmtDate(a.deadline) : 'Unterweisung',
      onClick: () => { listPopup.value.visible = false; openEditAssignmentFromTarget(a); },
      onRemove: () => removeAssignment(a),
    })),
  ];
  openListPopup('Zuweisungen – ' + label, entries, {
    label: 'Aufgabe zuweisen',
    action: () => { listPopup.value.visible = false; openCreateAssignmentForTarget(targetType, targetId); },
  });
}

// Alle Aufgaben eines Mitarbeiters als Liste: direkt zugewiesene und die aus seinen Gruppen
function openUserTasksPopup(user: any) {
  const entries: { label: string; sub?: string; onClick?: () => void }[] = [];

  const pushAssignments = (targetType: 'USER' | 'GROUP', targetId: string, origin: string) => {
    for (const a of getCourseAssignmentsForTarget(targetType, targetId)) {
      entries.push({
        label: courseTitle(a.courseId),
        sub: ['Kurs', origin, a.deadline ? 'Frist ' + fmtDate(a.deadline) : ''].filter(Boolean).join(' · '),
        onClick: () => { listPopup.value.visible = false; openEditAssignmentFromTarget(a); },
      });
    }
    for (const a of getInstructionAssignmentsForTarget(targetType, targetId)) {
      entries.push({
        label: instructionTitle(a.instructionId),
        sub: ['Unterweisung', origin, a.deadline ? 'Frist ' + fmtDate(a.deadline) : ''].filter(Boolean).join(' · '),
        onClick: () => { listPopup.value.visible = false; openEditAssignmentFromTarget(a); },
      });
    }
  };

  pushAssignments('USER', user.userId, 'direkt zugewiesen');
  for (const groupId of (userGroupMemberships.value[user.userId] ?? [])) {
    const groupName = groups.value.find((g) => g.groupId === groupId)?.name ?? '';
    pushAssignments('GROUP', groupId, groupName ? `über Gruppe ${groupName}` : 'über Gruppe');
  }

  openListPopup('Aufgaben – ' + displayName(user), entries);
}

// Mitarbeiter aus der Tabelle einer Gruppe zuordnen (Plus in der Gruppen-Spalte)
function openAddUserToGroupPopup(user: any) {
  const memberOf = new Set(userGroupMemberships.value[user.userId] ?? []);
  const entries = groupOptions.value
    .filter((o) => !memberOf.has(o.groupId))
    .map((o) => ({
      label: o.label,
      onClick: async () => {
        const orgId = store.getters['organisation/getOrganisationId'];
        await addUserToGroup(orgId, o.groupId, user.userId, store.getters.getJWT);
        const current = userGroupMemberships.value[user.userId] ?? [];
        userGroupMemberships.value[user.userId] = [...current, o.groupId];
        listPopup.value.visible = false;
      },
    }));
  openListPopup('Gruppe zuordnen – ' + displayName(user), entries);
}

// Ziele (wer ist zugewiesen) eines Kurses als Liste (Katalog-Tab)
function openCourseTargetsPopup(course: any) {
  const entries = getAssignmentsForCourse(course.id).map((a: any) => ({
    label: assignmentChipLabel(a),
    onClick: () => { listPopup.value.visible = false; openEditAssignment(course, a); },
  }));
  openListPopup('Zuweisungen – ' + course.title, entries);
}

const courseAssignSaving = ref(false);
const courseAssignError = ref('');

// Returns the course title for a given courseId (for displaying in group/user tab chips)
function courseTitle(courseId: string): string {
  const c = (catalogCourses.value as any[]).find((m: any) => m.id === courseId);
  if (c) return c.title;
  // Fallback: Slug lesbar machen ("harnkontinenz-pflege" -> "Harnkontinenz Pflege")
  return (courseId || '')
    .split(/[-_]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ') || courseId;
}

// All assignments for a specific course (used in catalog tab chips)
function getAssignmentsForCourse(courseId: string): any[] {
  return store.getters['courseAssignment/getAssignmentsByCourse'](courseId);
}

// All assignments for a specific target (used in groups/users tab chips)
function getAssignmentsForTarget(targetType: string, targetId: string): any[] {
  return store.getters['courseAssignment/getAssignmentsByTarget'](targetType, targetId);
}

// Chip label when displaying from catalog tab (shows who the assignment is for)
function assignmentChipLabel(a: any): string {
  const grp = (groups.value as any[]).find((g: any) => g.groupId === a.targetId);
  const usr = (users.value as any[]).find((u: any) => u.userId === a.targetId);
  const label = a.targetType === 'GROUP'
    ? (grp ? grp.name : a.targetId)
    : displayName(usr ? usr : { userId: a.targetId });
  return a.deadline
    ? label + ' (bis ' + new Date(a.deadline).toLocaleDateString('de-DE') + ')'
    : label;
}

// Chip label when displaying from groups/users tab (shows which course)
function assignmentCourseChipLabel(a: any): string {
  const title = courseTitle(a.courseId);
  return a.deadline
    ? title + ' (bis ' + new Date(a.deadline).toLocaleDateString('de-DE') + ')'
    : title;
}

// Open from catalog tab: course is pre-selected, user picks target
function openCreateAssignment(course: any) {
  courseAssignModalCourse.value = course;
  courseAssignModalMode.value = 'create';
  courseAssignTargetFixed.value = false;
  editingAssignment.value = null;
  courseAssignForm.value = { kind: 'course', instructionId: '', courseId: course.id, targetType: 'GROUP', targetId: '', deadline: '', recurAnnually: false, notifyDaysBefore: null, notifyCount: null };
  courseAssignError.value = '';
  courseAssignModalVisible.value = true;
}

// Open from groups/users tab: target is pre-selected, user picks course
function openCreateAssignmentForTarget(targetType: 'GROUP' | 'USER', targetId: string) {
  courseAssignModalCourse.value = null;
  courseAssignModalMode.value = 'create';
  courseAssignTargetFixed.value = true;
  editingAssignment.value = null;
  courseAssignForm.value = { kind: 'course', instructionId: '', courseId: '', targetType, targetId, deadline: '', recurAnnually: false, notifyDaysBefore: null, notifyCount: null };
  courseAssignError.value = '';
  courseAssignModalVisible.value = true;
}

// Open from the Unterweisungen tab: instruction is pre-selected, user picks target
function openCreateAssignmentForInstruction(instructionId: string) {
  courseAssignModalCourse.value = null;
  courseAssignModalMode.value = 'create';
  courseAssignTargetFixed.value = false;
  editingAssignment.value = null;
  courseAssignForm.value = { kind: 'instruction', instructionId, courseId: '', targetType: 'GROUP', targetId: '', deadline: '', recurAnnually: false, notifyDaysBefore: null, notifyCount: null };
  courseAssignError.value = '';
  courseAssignModalVisible.value = true;
}

// Edit existing assignment (Kurs ODER Unterweisung)
function openEditAssignment(course: any, assignment: any) {
  const isInstruction = assignment.kind === 'INSTRUCTION';
  courseAssignModalCourse.value = isInstruction ? null : course;
  courseAssignModalMode.value = 'edit';
  courseAssignTargetFixed.value = true;  // target is never editable in edit mode
  editingAssignment.value = assignment;
  courseAssignForm.value = {
    kind: isInstruction ? 'instruction' : 'course',
    instructionId: assignment.instructionId || '',
    courseId: assignment.courseId || '',
    targetType: assignment.targetType,
    targetId: assignment.targetId,
    deadline: assignment.deadline || '',
    recurAnnually: assignment.recurAnnually,
    notifyDaysBefore: assignment.notifyDaysBefore,
    notifyCount: assignment.notifyCount,
  };
  courseAssignError.value = '';
  courseAssignModalVisible.value = true;
}

// Edit from groups/users tab: resolve course name from catalog (bei Kursen)
function openEditAssignmentFromTarget(assignment: any) {
  const course = assignment.kind === 'INSTRUCTION'
    ? null
    : (catalogCourses.value as any[]).find((c: any) => c.id === assignment.courseId) || null;
  openEditAssignment(course, assignment);
}

async function saveAssignment() {
  const isInstruction = courseAssignForm.value.kind === 'instruction';
  const ref = isInstruction
    ? courseAssignForm.value.instructionId
    : (courseAssignModalCourse.value ? courseAssignModalCourse.value.id : courseAssignForm.value.courseId);

  if (!courseAssignForm.value.targetId || !ref) return;
  courseAssignSaving.value = true;
  courseAssignError.value = '';
  const orgId = store.getters['organisation/getOrganisationId'];
  const payload: any = {
    kind: isInstruction ? 'INSTRUCTION' : 'COURSE',
    targetType: courseAssignForm.value.targetType,
    targetId: courseAssignForm.value.targetId,
    deadline: courseAssignForm.value.deadline || null,
    recurAnnually: courseAssignForm.value.recurAnnually,
    notifyDaysBefore: courseAssignForm.value.notifyDaysBefore,
    notifyCount: courseAssignForm.value.notifyCount,
  };
  if (isInstruction) payload.instructionId = ref;
  else payload.courseId = ref;

  try {
    if (courseAssignModalMode.value === 'create') {
      await store.dispatch('courseAssignment/CREATE', { orgId, payload });
    } else {
      await store.dispatch('courseAssignment/UPDATE', {
        orgId,
        assignmentId: editingAssignment.value.assignmentId,
        payload,
      });
    }
    courseAssignModalVisible.value = false;
  } catch (e) {
    courseAssignError.value = 'Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.';
  } finally {
    courseAssignSaving.value = false;
  }
}

async function doDeleteAssignment() {
  if (!editingAssignment.value) return;
  const orgId = store.getters['organisation/getOrganisationId'];
  await store.dispatch('courseAssignment/DELETE', {
    orgId,
    assignmentId: editingAssignment.value.assignmentId,
  });
  courseAssignModalVisible.value = false;
}

// Load all assignments when groups or users tabs open; per-course when catalog opens
watch(activeTab, async (tab) => {
  const orgId = store.getters['organisation/getOrganisationId'];
  if (tab === 'catalog') {
    catalogLoading.value = true;
    await store.dispatch('lmsCourse/LOAD_CATALOG');
    catalogLoading.value = false;
    // If LOAD_ALL already ran (from groups/users tab), no need to do per-course loading
    if (!store.getters['courseAssignment/isAllLoaded']) {
      const courses = store.getters['lmsCourse/getModules'] as any[];
      await Promise.all(
        courses.map((c: any) =>
          store.dispatch('courseAssignment/LOAD_FOR_COURSE', { orgId, courseId: c.id })
        )
      );
    }
  } else if (tab === 'groups' || tab === 'users') {
    // Load catalog so courseTitle() works in chips
    store.dispatch('lmsCourse/LOAD_CATALOG');
    // Load all assignments once
    store.dispatch('courseAssignment/LOAD_ALL', orgId);
  }
});

// ── Aktivitäten ───────────────────────────────────────────
const courseYears = { 2022: 2022, 2023: 2023, 2024: 2024, 2025: 2025, 2026: 2026 };
const selectYear = ref(new Date().getFullYear());
const courses = ref<any[]>([]);
// getCourses uses the superadmin catalog (same source as catalogCourses)
const getCourses = computed(() => store.getters['lmsCourse/getModules']);

watch(selectYear, () => load());

function userHasCourseCompleted(userId: string, courseId: string) {
  const t = courses.value.find((i: any) => i.courseId == courseId && i.userId == userId);
  return t && t.passedAt ? t.passedAt : false;
}

async function load() {
  courses.value = [];
  const res = await getAllByOrganisation(
    store.getters['organisation/getOrganisationId'],
    selectYear.value,
    store.getters.getJWT
  );
  res.forEach((item: any) => courses.value.push(item));
}

async function getCompanyPDF() {
  await displayPDFByOrg(getCourses.value, users.value, selectYear.value, store, courses.value);
}

async function getUserPDF(userId: any) {
  await displayPDFByUser(
    getCourses.value,
    users.value.filter((u: any) => u.userId == userId),
    selectYear.value,
    store,
    courses.value
  );
}

// ── Abschlüsse: Kurse + Unterweisungen, Zertifikate (Browser-Druck) ──
const instructionCompletionsByUser = ref<Record<string, { instructionId: string; title: string; confirmedAt: number }[]>>({});

async function loadInstructionCompletions() {
  const orgId = store.getters['organisation/getOrganisationId'];
  if (!orgId) return;
  await store.dispatch('instruction/LOAD_ALL', { force: true });
  const list: any[] = store.getters['instruction/getAll'] || [];
  await Promise.all(list.map((i) => store.dispatch('instruction/LOAD_CONFIRMATIONS', i.instructionId).catch(() => [])));
  const byUser: Record<string, { instructionId: string; title: string; confirmedAt: number }[]> = {};
  list.forEach((ins) => {
    const confs: any[] = store.getters['instruction/getConfirmations'](ins.instructionId) || [];
    confs.forEach((c) => {
      (byUser[c.userId] = byUser[c.userId] || []).push({ instructionId: ins.instructionId, title: ins.title, confirmedAt: c.confirmedAt });
    });
  });
  instructionCompletionsByUser.value = byUser;
}

function tsDate(ts: number): string {
  return ts ? new Date(ts).toLocaleDateString('de-DE') : '';
}

function completedCoursesForUser(userId: string): CertItem[] {
  return courses.value
    .filter((a: any) => a.userId === userId && a.passedAt)
    .map((a: any) => ({ label: courseTitle(a.courseId), type: 'Kurs', date: tsDate(a.passedAt) }));
}

function completedInstructionsForUser(userId: string): CertItem[] {
  const confs = instructionCompletionsByUser.value[userId] || [];
  return confs
    .filter((c) => new Date(c.confirmedAt).getFullYear() === Number(selectYear.value))
    .map((c) => ({ label: c.title, type: 'Unterweisung', date: tsDate(c.confirmedAt) }));
}

function userHasAnyCompletion(userId: string): boolean {
  return completedCoursesForUser(userId).length > 0 || completedInstructionsForUser(userId).length > 0;
}

const orgNameForCert = computed(() => (organisation.value && organisation.value.name) || 'Einrichtung');
function today(): string { return new Date().toLocaleDateString('de-DE'); }

// Popup mit Liste der Abschlüsse; Klick auf Eintrag -> Einzel-Zertifikat
function openCompletionsPopup(user: any, items: CertItem[], title: string) {
  const name = displayName(user) || user.email || user.userName;
  const entries = items.map((it) => ({
    label: it.label,
    sub: it.type + ' · ' + it.date,
    onClick: () => {
      listPopup.value.visible = false;
      printCertificate({ orgName: orgNameForCert.value, employeeName: name, items: [it], dateStr: today() });
    },
  }));
  openListPopup(title + ' – ' + name, entries);
}

// Sammel-Zertifikat einer Person (alle Abschlüsse)
function printUserCombined(user: any) {
  const items = [...completedCoursesForUser(user.userId), ...completedInstructionsForUser(user.userId)];
  if (!items.length) return;
  printCertificate({
    orgName: orgNameForCert.value,
    employeeName: displayName(user) || user.email || user.userName,
    items,
    dateStr: today(),
  });
}

// Gesamtübersicht der ganzen Einrichtung
function printOrgOverviewAll() {
  const rows = (users.value as any[])
    .map((u: any) => ({
      name: displayName(u) || u.email || u.userName,
      items: [...completedCoursesForUser(u.userId), ...completedInstructionsForUser(u.userId)],
    }))
    .filter((r) => r.items.length > 0);
  printOrgOverview({ orgName: orgNameForCert.value, year: selectYear.value, dateStr: today(), rows });
}

// ── Einstellungen ─────────────────────────────────────────
const settingsForm = ref({ name: '', street: '', streetNo: '', addressAddition: '', postalCode: '', city: '' });
const settingsSaving = ref(false);
const settingsSaved = ref(false);
const logoPreview = ref<string | null>(null);
const logoUploading = ref(false);
const logoError = ref('');

watch(organisation, (org) => {
  if (!org) return;
  const c = org.data?.company || {};
  if (org.data?.logoUrl) logoPreview.value = org.data.logoUrl;
  settingsForm.value = {
    name: org.name || '',
    street: c.street || '',
    streetNo: c.streetNo || '',
    addressAddition: c.addressAddition || '',
    postalCode: c.postalCode || '',
    city: c.city || '',
  };
}, { immediate: true });

async function handleLogoUpload(event: Event) {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (!file) return;
  logoError.value = '';
  logoUploading.value = true;
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const publicUrl = await uploadLogo(orgId, file, store.getters.getJWT);
    logoPreview.value = publicUrl;
    // Logo-URL in Org-Daten speichern
    await store.dispatch('organisation/UPDATE', {
      company: { ...settingsForm.value },
      logoUrl: publicUrl,
    });
  } catch {
    logoError.value = 'Upload fehlgeschlagen. Bitte versuchen Sie es erneut.';
  } finally {
    logoUploading.value = false;
  }
}

async function saveSettings() {
  settingsSaving.value = true;
  settingsSaved.value = false;
  try {
    await store.dispatch('organisation/UPDATE', {
      company: { ...settingsForm.value },
    });
    settingsSaved.value = true;
    setTimeout(() => { settingsSaved.value = false; }, 3000);
  } finally {
    settingsSaving.value = false;
  }
}

// ── Gruppen ───────────────────────────────────────────────
// weight/parentGroupId sind erst ab organisation-SDK > 1.27 typisiert;
// der Service unterstützt sie bereits. Cast entfällt nach dem SDK-Bump.
const updateGroupFull = updateGroupApi as unknown as (
  organisationId: string,
  groupId: string,
  data: { name?: string; parentGroupId?: string | null; weight?: number },
  JWT: string,
) => Promise<GroupNode>;

const groups = ref<GroupNode[]>([]);
const groupModalMode = ref<'create' | 'edit'>('create');
const groupModalVisible = ref(false);
const groupModalParentId = ref<string | null>(null);
const groupModalEditId = ref<string | null>(null);
const groupModalName = ref('');
const groupModalWeight = ref<number | null>(null);
const groupModalSaving = ref(false);
const groupError = ref('');
const groupDragActive = ref(false);
const groupDragError = ref('');
let groupDragErrorTimer: ReturnType<typeof setTimeout> | undefined;

// Assign modal
const assignModalVisible = ref(false);
const assignModalGroup = ref<Group | null>(null);
const assignSearch = ref('');
const assignLoadingMembers = ref(false);
const groupAssignPanelMembers = ref<string[]>([]);

// Group membership map: userId → groupId[]
const userGroupMemberships = ref<Record<string, string[]>>({});

const assignFilteredUsers = computed(() => {
  const q = assignSearch.value.toLowerCase().trim();
  if (!q) return users.value;
  return (users.value as any[]).filter((u: any) => {
    const name = displayName(u).toLowerCase();
    const email = (u.email || u.userName || '').toLowerCase();
    return name.includes(q) || email.includes(q);
  });
});

// Remove-from-group confirmation
const removeGroupConfirm = ref<{ userId: string; groupId: string } | null>(null);

function removeUserFromGroupDirect(userId: string, groupId: string) {
  removeGroupConfirm.value = { userId, groupId };
}

async function confirmRemoveFromGroup() {
  if (!removeGroupConfirm.value) return;
  const { userId, groupId } = removeGroupConfirm.value;
  const orgId = store.getters['organisation/getOrganisationId'];
  await removeUserFromGroup(orgId, groupId, userId, store.getters.getJWT);
  if (userGroupMemberships.value[userId]) {
    userGroupMemberships.value[userId] = userGroupMemberships.value[userId].filter((id) => id !== groupId);
  }
  removeGroupConfirm.value = null;
}

function userGroupNames(userId: string): string {
  const groupIds = userGroupMemberships.value[userId] ?? [];
  return groupIds
    .map((id) => groups.value.find((g) => g.groupId === id)?.name ?? '')
    .filter(Boolean)
    .join(', ');
}

function groupChildren(parentId: string | null): GroupNode[] {
  return groups.value
    .filter((g) => (g.parentGroupId ?? null) === parentId)
    .sort(
      (a, b) =>
        (a.weight ?? Number.MAX_SAFE_INTEGER) - (b.weight ?? Number.MAX_SAFE_INTEGER) ||
        a.createdAt - b.createdAt
    );
}

/** Alle Gruppen in Hierarchie-Reihenfolge (wie im Gruppen-Tab) mit Einrückung
 *  fürs native <select>. Gruppen, deren Elterngruppe fehlt, werden ans Ende
 *  angehängt, damit keine Gruppe aus der Auswahl fällt. */
const groupOptions = computed<{ groupId: string; label: string }[]>(() => {
  const options: { groupId: string; label: string }[] = [];
  const seen = new Set<string>();
  function walk(parentId: string | null, depth: number) {
    for (const g of groupChildren(parentId)) {
      if (seen.has(g.groupId)) continue;
      seen.add(g.groupId);
      const indent = '\u00A0\u00A0\u00A0'.repeat(depth);
      options.push({ groupId: g.groupId, label: depth > 0 ? `${indent}↳ ${g.name}` : g.name });
      walk(g.groupId, depth + 1);
    }
  }
  walk(null, 0);
  for (const g of groups.value) {
    if (!seen.has(g.groupId)) {
      options.push({ groupId: g.groupId, label: g.name });
    }
  }
  return options;
});

/** Tiefe des Teilbaums unterhalb von groupId (1 = keine Kinder). */
function groupSubtreeDepth(groupId: string): number {
  const children = groups.value.filter((g) => g.parentGroupId === groupId);
  if (!children.length) return 1;
  return 1 + Math.max(...children.map((c) => groupSubtreeDepth(c.groupId)));
}

function groupDescendants(groupId: string): GroupNode[] {
  const children = groups.value.filter((g) => g.parentGroupId === groupId);
  return children.concat(...children.map((c) => groupDescendants(c.groupId)));
}

function showGroupDragError(message: string) {
  groupDragError.value = message;
  if (groupDragErrorTimer) clearTimeout(groupDragErrorTimer);
  groupDragErrorTimer = setTimeout(() => { groupDragError.value = ''; }, 5000);
}

function onGroupDragChange(evt: any, newParentId: string | null) {
  // Bei Listenwechsel feuert die Zielliste 'added', die Quellliste 'removed' —
  // 'removed' wird deshalb ignoriert.
  const info = evt.added ?? evt.moved;
  if (!info) return;
  void persistGroupMove(info.element.groupId, newParentId, info.newIndex);
}

async function persistGroupMove(groupId: string, newParentId: string | null, newIndex: number) {
  const moved = groups.value.find((g) => g.groupId === groupId);
  if (!moved) return;
  const oldParentId = moved.parentGroupId ?? null;
  const parentChanged = oldParentId !== newParentId;

  if (parentChanged) {
    const parent = newParentId ? groups.value.find((g) => g.groupId === newParentId) : null;
    if (newParentId && !parent) return;
    const newLevel = parent ? parent.level + 1 : 1;
    if (newLevel + groupSubtreeDepth(groupId) - 1 > 3) {
      showGroupDragError('Verschieben nicht möglich: Es sind höchstens drei Ebenen erlaubt.');
      // Re-Render aus dem unveränderten Zustand stellt die alte Position wieder her.
      groups.value = [...groups.value];
      return;
    }
    const levelDelta = newLevel - moved.level;
    if (levelDelta !== 0) groupDescendants(groupId).forEach((d) => { d.level += levelDelta; });
    moved.level = newLevel;
    moved.parentGroupId = newParentId;
  }

  // Neue Reihenfolge der Ziel-Geschwister; weight = Index, nur Änderungen speichern.
  const siblings = groupChildren(newParentId).filter((g) => g.groupId !== groupId);
  siblings.splice(newIndex, 0, moved);

  const updates: Array<{ groupId: string; data: { parentGroupId?: string | null; weight?: number } }> = [];
  siblings.forEach((g, i) => {
    const data: { parentGroupId?: string | null; weight?: number } = {};
    if (g.weight !== i) { g.weight = i; data.weight = i; }
    if (g.groupId === groupId && parentChanged) data.parentGroupId = newParentId;
    if (Object.keys(data).length) updates.push({ groupId: g.groupId, data });
  });
  if (!updates.length) return;

  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const jwt = store.getters.getJWT;
    await Promise.all(updates.map((u) => updateGroupFull(orgId, u.groupId, u.data, jwt)));
  } catch {
    showGroupDragError('Die Änderung konnte nicht gespeichert werden. Die Ansicht wurde zurückgesetzt.');
    await loadGroups();
  }
}

/** Mitarbeiter, die dieser Gruppe direkt zugeordnet sind. */
function groupMembers(groupId: string): any[] {
  return users.value.filter((u: any) =>
    (userGroupMemberships.value[u.userId] ?? []).includes(groupId)
  );
}

function openCreateGroup(parentId: string | null = null) {
  groupModalMode.value = 'create';
  groupModalParentId.value = parentId;
  groupModalEditId.value = null;
  groupModalName.value = '';
  groupModalWeight.value = null;
  groupError.value = '';
  groupModalVisible.value = true;
}

function openEditGroup(group: GroupNode) {
  groupModalMode.value = 'edit';
  groupModalEditId.value = group.groupId;
  groupModalParentId.value = group.parentGroupId ?? null;
  groupModalName.value = group.name;
  groupModalWeight.value = typeof group.weight === 'number' ? group.weight : null;
  groupError.value = '';
  groupModalVisible.value = true;
}

async function saveGroupModal() {
  if (!groupModalName.value.trim()) { groupError.value = 'Bitte einen Namen eingeben.'; return; }
  groupModalSaving.value = true;
  groupError.value = '';
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const jwt = store.getters.getJWT;
    if (groupModalMode.value === 'create') {
      const created = await createGroup(orgId, { name: groupModalName.value.trim(), parentGroupId: groupModalParentId.value }, jwt);
      groups.value.push(created);
    } else if (groupModalEditId.value) {
      const data: { name: string; weight?: number } = { name: groupModalName.value.trim() };
      if (typeof groupModalWeight.value === 'number' && Number.isFinite(groupModalWeight.value)) {
        data.weight = groupModalWeight.value;
      }
      const updated = await updateGroupFull(orgId, groupModalEditId.value, data, jwt);
      const idx = groups.value.findIndex((g) => g.groupId === groupModalEditId.value);
      if (idx >= 0) groups.value[idx] = updated;
    }
    groupModalVisible.value = false;
  } catch (e: any) {
    groupError.value = e?.response?.data?.['error-message'] ?? 'Ein Fehler ist aufgetreten.';
  } finally {
    groupModalSaving.value = false;
  }
}

async function confirmDeleteGroup(group: Group) {
  if (!confirm(`Gruppe „${group.name}" wirklich löschen? Alle Mitgliedschaften werden aufgehoben.`)) return;
  const orgId = store.getters['organisation/getOrganisationId'];
  await deleteGroup(orgId, group.groupId, store.getters.getJWT);
  groups.value = groups.value.filter((g) => g.groupId !== group.groupId);
}

async function openAssignModal(group: Group) {
  assignModalGroup.value = group;
  assignSearch.value = '';
  groupAssignPanelMembers.value = [];
  assignLoadingMembers.value = true;
  assignModalVisible.value = true;
  try {
    const orgId = store.getters['organisation/getOrganisationId'];
    const members = await import('@training24/organisation/src/group').then((m) =>
      m.getUsersInGroup(orgId, group.groupId, store.getters.getJWT)
    );
    groupAssignPanelMembers.value = members.map((m: any) => m.userId);
  } finally {
    assignLoadingMembers.value = false;
  }
}

async function closeAssignModal() {
  assignModalVisible.value = false;
  assignModalGroup.value = null;
  await loadGroupMemberships();
}

async function toggleGroupMember(userId: string) {
  const groupId = assignModalGroup.value?.groupId;
  if (!groupId) return;
  const orgId = store.getters['organisation/getOrganisationId'];
  const jwt = store.getters.getJWT;
  const isMember = groupAssignPanelMembers.value.includes(userId);
  if (isMember) {
    await removeUserFromGroup(orgId, groupId, userId, jwt);
    groupAssignPanelMembers.value = groupAssignPanelMembers.value.filter((id) => id !== userId);
  } else {
    await addUserToGroup(orgId, groupId, userId, jwt);
    groupAssignPanelMembers.value.push(userId);
  }
}

async function loadGroups() {
  const orgId = store.getters['organisation/getOrganisationId'];
  if (!orgId) return;
  groups.value = await getGroups(orgId, store.getters.getJWT);
}

async function loadGroupMemberships() {
  const orgId = store.getters['organisation/getOrganisationId'];
  if (!orgId || groups.value.length === 0) return;
  const jwt = store.getters.getJWT;
  const map: Record<string, string[]> = {};
  await Promise.all(
    groups.value.map(async (group) => {
      try {
        const members = await import('@training24/organisation/src/group').then((m) =>
          m.getUsersInGroup(orgId, group.groupId, jwt)
        );
        for (const m of members as any[]) {
          if (!map[m.userId]) map[m.userId] = [];
          map[m.userId].push(group.groupId);
        }
      } catch (e) { /* Gruppe ohne Mitglieder oder Fehler — überspringen */ }
    })
  );
  userGroupMemberships.value = map;
}

/** Nach Anlegen eines Mitarbeiters: Liste und Gruppenzuordnungen neu laden */
async function onUserCreated() {
  await loadProfiles();
  await loadGroupMemberships();
}

// ── Lifecycle ─────────────────────────────────────────────
onMounted(async () => {
  await Promise.all([
    load(),
    loadProfiles(),
    loadGroups(),
    loadInstructionCompletions(),
    store.dispatch('lmsCourse/LOAD_CATALOG'),
  ]);
  await loadGroupMemberships();
  // Zuweisungen vorladen damit Kurs-Chips sofort sichtbar sind
  const orgId = store.getters['organisation/getOrganisationId'];
  if (orgId) store.dispatch('courseAssignment/LOAD_ALL', orgId);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(organisation)?.name ?? 'Meine Einrichtung'), 1),
        _createElementVNode("nav", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.id,
              class: _normalizeClass(["tab-btn", { active: activeTab.value === tab.id }]),
              onClick: ($event: any) => (activeTab.value = tab.id)
            }, _toDisplayString(tab.label), 11, _hoisted_5))
          }), 128))
        ])
      ]),
      (activeTab.value === 'users')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userSearch).value = $event)),
                  type: "search",
                  class: "reminder-search",
                  placeholder: "Nach Name oder E-Mail suchen",
                  "aria-label": "Mitarbeiter nach Name oder E-Mail suchen"
                }, null, 512), [
                  [_vModelText, userSearch.value]
                ]),
                _createElementVNode("a", _hoisted_10, [
                  _createVNode(_unref(UserPlusIcon), { size: "16" }),
                  _createTextVNode(" Mitarbeiter anlegen ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _createElementVNode("th", null, [
                      _createElementVNode("span", _hoisted_17, [
                        _createTextVNode(" Aufgaben "),
                        _createElementVNode("span", _hoisted_18, [
                          _createElementVNode("button", _hoisted_19, [
                            _createVNode(_unref(InfoIcon), { size: "13" })
                          ]),
                          _hoisted_20
                        ])
                      ])
                    ]),
                    _hoisted_21
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredUsers), (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.userId
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(userFirstName(user)), 1),
                        (user.type === 'OWNER' || user.type === 'ADMIN')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Administrator"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(userLastName(user)), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(user.email || user.userName), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((userGroupMemberships.value[user.userId] ?? []), (groupId) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: groupId,
                              class: "group-chip",
                              title: `Aus ${groups.value.find(g => g.groupId === groupId)?.name ?? ''} entfernen`,
                              onClick: ($event: any) => (removeUserFromGroupDirect(user.userId, groupId))
                            }, [
                              _createTextVNode(_toDisplayString(groups.value.find(g => g.groupId === groupId)?.name ?? groupId), 1),
                              _hoisted_28
                            ], 8, _hoisted_27))
                          }), 128)),
                          _createElementVNode("button", {
                            class: "chip-add-btn",
                            title: "Zu Gruppe hinzufügen",
                            onClick: ($event: any) => (openAddUserToGroupPopup(user))
                          }, [
                            _createVNode(_unref(PlusIcon), { size: "13" })
                          ], 8, _hoisted_29)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_30, [
                          (userTaskCount(user) > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "count-chip",
                                onClick: ($event: any) => (openUserTasksPopup(user))
                              }, _toDisplayString(userTaskCount(user)) + " " + _toDisplayString(userTaskCount(user) === 1 ? 'Aufgabe' : 'Aufgaben'), 9, _hoisted_31))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            class: "chip-add-btn",
                            title: "Aufgabe zuweisen",
                            onClick: ($event: any) => (openCreateAssignmentForTarget('USER', user.userId))
                          }, [
                            _createVNode(_unref(PlusIcon), { size: "13" })
                          ], 8, _hoisted_32)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("button", {
                            class: "icon-btn",
                            title: "Bearbeiten",
                            onClick: ($event: any) => (openEditUser(user))
                          }, [
                            _createVNode(_unref(Edit2Icon), { size: "15" })
                          ], 8, _hoisted_35),
                          (user.type !== 'OWNER')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "icon-btn danger",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#deleteUser",
                                onClick: ($event: any) => (selectedUserUserId.value = user.userId),
                                title: "Entfernen"
                              }, [
                                _createVNode(_unref(TrashIcon), { size: "16" })
                              ], 8, _hoisted_36))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128)),
                  (_unref(users).length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_37, _hoisted_39))
                    : (_unref(filteredUsers).length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_40, _hoisted_42))
                      : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'groups')
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openCreateGroup(null)))
                }, [
                  _createVNode(_unref(PlusIcon), { size: "16" }),
                  _createTextVNode(" Gruppe anlegen ")
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              (groups.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Noch keine Gruppen angelegt. "))
                : _createCommentVNode("", true),
              (groupDragError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(groupDragError.value), 1))
                : _createCommentVNode("", true),
              _createVNode(_unref(draggable), {
                list: groupChildren(null),
                "item-key": "groupId",
                group: "org-groups",
                class: "group-root-list",
                animation: 160,
                "ghost-class": "group-drag-ghost",
                filter: "button, a",
                "prevent-on-filter": false,
                "force-fallback": true,
                "fallback-tolerance": 4,
                onStart: _cache[6] || (_cache[6] = ($event: any) => (groupDragActive.value = true)),
                onEnd: _cache[7] || (_cache[7] = ($event: any) => (groupDragActive.value = false)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (onGroupDragChange($event, null)))
              }, {
                item: _withCtx(({ element: rootGroup }) => [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, _toDisplayString(rootGroup.name), 1),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_unref(BookOpenIcon), {
                              size: "12",
                              class: "group-member-icon"
                            }),
                            _createElementVNode("button", {
                              class: "count-chip",
                              onClick: ($event: any) => (openAssignmentsPopup('GROUP', rootGroup.groupId, rootGroup.name))
                            }, _toDisplayString(assignmentCountForTarget('GROUP', rootGroup.groupId)) + " " + _toDisplayString(assignmentCountForTarget('GROUP', rootGroup.groupId) === 1 ? 'Aufgabe' : 'Aufgaben'), 9, _hoisted_56)
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("button", {
                              class: "count-chip",
                              onClick: ($event: any) => (openAssignModal(rootGroup))
                            }, _toDisplayString(groupMembers(rootGroup.groupId).length) + " Mitarbeiter", 9, _hoisted_58)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("button", {
                          class: "icon-btn",
                          title: "Umbenennen",
                          onClick: ($event: any) => (openEditGroup(rootGroup))
                        }, [
                          _createVNode(_unref(Edit2Icon), { size: "15" })
                        ], 8, _hoisted_60),
                        _createElementVNode("button", {
                          class: "icon-btn danger",
                          title: "Löschen",
                          onClick: ($event: any) => (confirmDeleteGroup(rootGroup))
                        }, [
                          _createVNode(_unref(TrashIcon), { size: "15" })
                        ], 8, _hoisted_61)
                      ])
                    ]),
                    (groupChildren(rootGroup.groupId).length || groupDragActive.value)
                      ? (_openBlock(), _createBlock(_unref(draggable), {
                          key: 0,
                          list: groupChildren(rootGroup.groupId),
                          "item-key": "groupId",
                          group: "org-groups",
                          class: _normalizeClass(["group-children", { 'group-drop-zone': groupDragActive.value && groupChildren(rootGroup.groupId).length === 0 }]),
                          animation: 160,
                          "ghost-class": "group-drag-ghost",
                          filter: "button, a",
                          "prevent-on-filter": false,
                          "force-fallback": true,
                          "fallback-tolerance": 4,
                          onStart: _cache[4] || (_cache[4] = ($event: any) => (groupDragActive.value = true)),
                          onEnd: _cache[5] || (_cache[5] = ($event: any) => (groupDragActive.value = false)),
                          onChange: ($event: any) => (onGroupDragChange($event, rootGroup.groupId))
                        }, {
                          item: _withCtx(({ element: childGroup }) => [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, _toDisplayString(childGroup.name), 1),
                                  _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("div", _hoisted_67, [
                                      _createVNode(_unref(BookOpenIcon), {
                                        size: "12",
                                        class: "group-member-icon"
                                      }),
                                      _createElementVNode("button", {
                                        class: "count-chip",
                                        onClick: ($event: any) => (openAssignmentsPopup('GROUP', childGroup.groupId, childGroup.name))
                                      }, _toDisplayString(assignmentCountForTarget('GROUP', childGroup.groupId)) + " " + _toDisplayString(assignmentCountForTarget('GROUP', childGroup.groupId) === 1 ? 'Aufgabe' : 'Aufgaben'), 9, _hoisted_68)
                                    ]),
                                    _createElementVNode("div", _hoisted_69, [
                                      _createElementVNode("button", {
                                        class: "count-chip",
                                        onClick: ($event: any) => (openAssignModal(childGroup))
                                      }, _toDisplayString(groupMembers(childGroup.groupId).length) + " Mitarbeiter", 9, _hoisted_70)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_71, [
                                  _createElementVNode("button", {
                                    class: "icon-btn",
                                    title: "Umbenennen",
                                    onClick: ($event: any) => (openEditGroup(childGroup))
                                  }, [
                                    _createVNode(_unref(Edit2Icon), { size: "15" })
                                  ], 8, _hoisted_72),
                                  _createElementVNode("button", {
                                    class: "icon-btn danger",
                                    title: "Löschen",
                                    onClick: ($event: any) => (confirmDeleteGroup(childGroup))
                                  }, [
                                    _createVNode(_unref(TrashIcon), { size: "15" })
                                  ], 8, _hoisted_73)
                                ])
                              ]),
                              (groupChildren(childGroup.groupId).length || groupDragActive.value)
                                ? (_openBlock(), _createBlock(_unref(draggable), {
                                    key: 0,
                                    list: groupChildren(childGroup.groupId),
                                    "item-key": "groupId",
                                    group: "org-groups",
                                    class: _normalizeClass(["group-children group-children-l3", { 'group-drop-zone': groupDragActive.value && groupChildren(childGroup.groupId).length === 0 }]),
                                    animation: 160,
                                    "ghost-class": "group-drag-ghost",
                                    filter: "button, a",
                                    "prevent-on-filter": false,
                                    "force-fallback": true,
                                    "fallback-tolerance": 4,
                                    onStart: _cache[2] || (_cache[2] = ($event: any) => (groupDragActive.value = true)),
                                    onEnd: _cache[3] || (_cache[3] = ($event: any) => (groupDragActive.value = false)),
                                    onChange: ($event: any) => (onGroupDragChange($event, childGroup.groupId))
                                  }, {
                                    item: _withCtx(({ element: grandchildGroup }) => [
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("div", _hoisted_75, [
                                          _createElementVNode("div", _hoisted_76, [
                                            _createElementVNode("div", _hoisted_77, _toDisplayString(grandchildGroup.name), 1),
                                            _createElementVNode("div", _hoisted_78, [
                                              _createElementVNode("div", _hoisted_79, [
                                                _createVNode(_unref(BookOpenIcon), {
                                                  size: "12",
                                                  class: "group-member-icon"
                                                }),
                                                _createElementVNode("button", {
                                                  class: "count-chip",
                                                  onClick: ($event: any) => (openAssignmentsPopup('GROUP', grandchildGroup.groupId, grandchildGroup.name))
                                                }, _toDisplayString(assignmentCountForTarget('GROUP', grandchildGroup.groupId)) + " " + _toDisplayString(assignmentCountForTarget('GROUP', grandchildGroup.groupId) === 1 ? 'Aufgabe' : 'Aufgaben'), 9, _hoisted_80)
                                              ]),
                                              _createElementVNode("div", _hoisted_81, [
                                                _createElementVNode("button", {
                                                  class: "count-chip",
                                                  onClick: ($event: any) => (openAssignModal(grandchildGroup))
                                                }, _toDisplayString(groupMembers(grandchildGroup.groupId).length) + " Mitarbeiter", 9, _hoisted_82)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("button", {
                                              class: "icon-btn",
                                              title: "Umbenennen",
                                              onClick: ($event: any) => (openEditGroup(grandchildGroup))
                                            }, [
                                              _createVNode(_unref(Edit2Icon), { size: "15" })
                                            ], 8, _hoisted_84),
                                            _createElementVNode("button", {
                                              class: "icon-btn danger",
                                              title: "Löschen",
                                              onClick: ($event: any) => (confirmDeleteGroup(grandchildGroup))
                                            }, [
                                              _createVNode(_unref(TrashIcon), { size: "15" })
                                            ], 8, _hoisted_85)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["list", "class", "onChange"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["list", "class", "onChange"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["list"])
            ]),
            (groupModalVisible.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "group-modal-backdrop",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (groupModalVisible.value = false), ["self"]))
                }, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("div", _hoisted_87, _toDisplayString(groupModalMode.value === 'create' ? (groupModalParentId.value ? 'Untergruppe anlegen' : 'Gruppe anlegen') : 'Gruppe bearbeiten'), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((groupModalName).value = $event)),
                      type: "text",
                      class: "settings-input",
                      placeholder: "Name der Gruppe",
                      onKeyup: _withKeys(saveGroupModal, ["enter"]),
                      autofocus: ""
                    }, null, 40, _hoisted_88), [
                      [_vModelText, groupModalName.value]
                    ]),
                    (groupModalMode.value === 'edit')
                      ? (_openBlock(), _createElementBlock("label", _hoisted_89, [
                          _hoisted_90,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((groupModalWeight).value = $event)),
                            type: "number",
                            class: "settings-input",
                            placeholder: "z. B. 0",
                            onKeyup: _withKeys(saveGroupModal, ["enter"])
                          }, null, 40, _hoisted_91), [
                            [
                              _vModelText,
                              groupModalWeight.value,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _hoisted_92
                        ]))
                      : _createCommentVNode("", true),
                    (groupError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(groupError.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("button", {
                        class: "btn-ghost",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (groupModalVisible.value = false))
                      }, "Abbrechen"),
                      _createElementVNode("button", {
                        class: "btn-primary",
                        disabled: groupModalSaving.value,
                        onClick: saveGroupModal
                      }, _toDisplayString(groupModalSaving.value ? 'Wird gespeichert…' : 'Speichern'), 9, _hoisted_95)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (assignModalVisible.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "group-modal-backdrop",
                  onClick: _withModifiers(closeAssignModal, ["self"])
                }, [
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", null, [
                        _hoisted_99,
                        _createElementVNode("div", _hoisted_100, _toDisplayString(assignModalGroup.value?.name), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "group-modal-close",
                        title: "Schließen",
                        onClick: closeAssignModal
                      }, [
                        _createVNode(_unref(XIcon), { size: "18" })
                      ])
                    ]),
                    _hoisted_101,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((assignSearch).value = $event)),
                      type: "text",
                      class: "settings-input",
                      placeholder: "Mitarbeiter suchen…"
                    }, null, 512), [
                      [_vModelText, assignSearch.value]
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      (assignLoadingMembers.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_103, "Wird geladen…"))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(assignFilteredUsers), (user) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: user.userId,
                                class: "assign-label"
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: groupAssignPanelMembers.value.includes(user.userId),
                                  onChange: ($event: any) => (toggleGroupMember(user.userId))
                                }, null, 40, _hoisted_104),
                                _createElementVNode("span", _hoisted_105, [
                                  _createElementVNode("span", _hoisted_106, _toDisplayString(displayName(user) || user.email || user.userName), 1),
                                  (displayName(user))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_107, _toDisplayString(user.email || user.userName), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128)),
                            (_unref(assignFilteredUsers).length === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_108, " Keine Mitarbeiter gefunden. "))
                              : _createCommentVNode("", true)
                          ], 64))
                    ]),
                    _createElementVNode("div", { class: "group-modal-footer" }, [
                      _createElementVNode("button", {
                        class: "btn-primary",
                        onClick: closeAssignModal
                      }, "Fertig")
                    ])
                  ])
                ], 8, _hoisted_96))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'catalog')
        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
            _hoisted_110,
            (catalogLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_111, " Wird geladen… "))
              : (_openBlock(), _createElementBlock("div", _hoisted_112, [
                  _createElementVNode("table", _hoisted_113, [
                    _hoisted_114,
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(catalogCourses), (course) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: course.id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_115, _toDisplayString(course.title), 1),
                            (course.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_116, _toDisplayString(course.description), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, [
                            (course.category)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(course.category), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_118, "—"))
                          ]),
                          _createElementVNode("td", null, _toDisplayString(course.duration_minutes ? course.duration_minutes + ' Min.' : '—'), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_119, [
                              (getAssignmentsForCourse(course.id).length > 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "count-chip",
                                    onClick: ($event: any) => (openCourseTargetsPopup(course))
                                  }, _toDisplayString(getAssignmentsForCourse(course.id).length) + " zugewiesen", 9, _hoisted_120))
                                : (_openBlock(), _createElementBlock("span", _hoisted_121, "—"))
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_122, [
                            _createElementVNode("button", {
                              class: "btn-ghost small",
                              onClick: ($event: any) => (openCreateAssignment(course))
                            }, [
                              _createVNode(_unref(PlusIcon), { size: "14" }),
                              _createTextVNode(" Zuweisen ")
                            ], 8, _hoisted_123)
                          ])
                        ]))
                      }), 128)),
                      (_unref(catalogCourses).length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_124, _hoisted_126))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
          ]))
        : _createCommentVNode("", true),
      (listPopup.value.visible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "group-modal-backdrop",
            onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (listPopup.value.visible = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, _toDisplayString(listPopup.value.title), 1),
              _createElementVNode("ul", _hoisted_129, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listPopup.value.entries, (e, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: i,
                    class: _normalizeClass({ clickable: !!e.onClick }),
                    onClick: ($event: any) => (e.onClick && e.onClick())
                  }, [
                    _createElementVNode("span", _hoisted_131, [
                      _createElementVNode("span", _hoisted_132, _toDisplayString(e.label), 1),
                      (e.sub)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_133, _toDisplayString(e.sub), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (e.onRemove)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "icon-btn danger lp-remove",
                          title: "Entfernen",
                          onClick: _withModifiers(($event: any) => (e.onRemove()), ["stop"])
                        }, [
                          _createVNode(_unref(TrashIcon), { size: "14" })
                        ], 8, _hoisted_134))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_130))
                }), 128)),
                (!listPopup.value.entries.length)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_135, "Keine Einträge."))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_136, [
                (listPopup.value.onAdd)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-ghost",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (listPopup.value.onAdd.action()))
                    }, [
                      _createVNode(_unref(PlusIcon), { size: "14" }),
                      _createTextVNode(" " + _toDisplayString(listPopup.value.onAdd.label), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (listPopup.value.visible = false))
                }, "Schließen")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (courseAssignModalVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "group-modal-backdrop",
            onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (courseAssignModalVisible.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("div", _hoisted_138, _toDisplayString(courseAssignModalMode.value === 'create' ? 'Aufgabe zuweisen' : 'Zuweisung bearbeiten'), 1),
              (courseAssignTargetFixed.value && courseAssignModalMode.value === 'create')
                ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                    _hoisted_140,
                    _createElementVNode("div", _hoisted_141, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["toggle-btn", { active: courseAssignForm.value.kind === 'course' }]),
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (courseAssignForm.value.kind = 'course'))
                      }, "Kurs", 2),
                      _createElementVNode("button", {
                        class: _normalizeClass(["toggle-btn", { active: courseAssignForm.value.kind === 'instruction' }]),
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (courseAssignForm.value.kind = 'instruction'))
                      }, "Unterweisung", 2)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (courseAssignForm.value.kind === 'instruction')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (courseAssignModalMode.value === 'create')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                          _hoisted_143,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((courseAssignForm.value.instructionId) = $event)),
                            class: "settings-input"
                          }, [
                            _hoisted_144,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allInstructions), (i) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: i.instructionId,
                                value: i.instructionId
                              }, _toDisplayString(i.title), 9, _hoisted_145))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, courseAssignForm.value.instructionId]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_146, _toDisplayString(instructionTitle(courseAssignForm.value.instructionId)), 1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (!courseAssignModalCourse.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                          _hoisted_148,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((courseAssignForm.value.courseId) = $event)),
                            class: "settings-input"
                          }, [
                            _hoisted_149,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(catalogCourses), (c) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: c.id,
                                value: c.id
                              }, _toDisplayString(c.title), 9, _hoisted_150))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, courseAssignForm.value.courseId]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_151, _toDisplayString(courseAssignModalCourse.value.title), 1))
                  ], 64)),
              (!courseAssignTargetFixed.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_152, [
                      _hoisted_153,
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["toggle-btn", { active: courseAssignForm.value.targetType === 'GROUP' }]),
                          onClick: _cache[21] || (_cache[21] = ($event: any) => {courseAssignForm.value.targetType = 'GROUP'; courseAssignForm.value.targetId = ''})
                        }, "Gruppe", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["toggle-btn", { active: courseAssignForm.value.targetType === 'USER' }]),
                          onClick: _cache[22] || (_cache[22] = ($event: any) => {courseAssignForm.value.targetType = 'USER'; courseAssignForm.value.targetId = ''})
                        }, "Mitarbeiter:in", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_155, [
                      _createElementVNode("label", _hoisted_156, [
                        _createTextVNode(_toDisplayString(courseAssignForm.value.targetType === 'GROUP' ? 'Gruppe' : 'Person') + " ", 1),
                        _hoisted_157
                      ]),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((courseAssignForm.value.targetId) = $event)),
                        class: "settings-input"
                      }, [
                        _hoisted_158,
                        (courseAssignForm.value.targetType === 'GROUP')
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(groupOptions), (g) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: g.groupId,
                                value: g.groupId
                              }, _toDisplayString(g.label), 9, _hoisted_159))
                            }), 128))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(users), (u) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: u.userId,
                                value: u.userId
                              }, _toDisplayString(displayName(u) || u.email || u.userName), 9, _hoisted_160))
                            }), 128))
                      ], 512), [
                        [_vModelSelect, courseAssignForm.value.targetId]
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_161, [
                _hoisted_162,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((courseAssignForm.value.deadline) = $event)),
                  type: "date",
                  class: "settings-input"
                }, null, 512), [
                  [_vModelText, courseAssignForm.value.deadline]
                ])
              ]),
              _createElementVNode("div", _hoisted_163, [
                _hoisted_164,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((courseAssignForm.value.recurAnnually) = $event)),
                  type: "checkbox",
                  class: "toggle-checkbox"
                }, null, 512), [
                  [_vModelCheckbox, courseAssignForm.value.recurAnnually]
                ])
              ]),
              _createElementVNode("div", _hoisted_165, [
                _hoisted_166,
                _createElementVNode("div", _hoisted_167, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((courseAssignForm.value.notifyDaysBefore) = $event)),
                    type: "number",
                    min: "0",
                    max: "365",
                    class: "settings-input notify-days-input",
                    placeholder: "z. B. 30"
                  }, null, 512), [
                    [
                      _vModelText,
                      courseAssignForm.value.notifyDaysBefore,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _hoisted_168
                ]),
                _hoisted_169
              ]),
              _createElementVNode("div", _hoisted_170, [
                _hoisted_171,
                _createElementVNode("div", _hoisted_172, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((courseAssignForm.value.notifyCount) = $event)),
                    type: "number",
                    min: "0",
                    max: "10",
                    class: "settings-input notify-count-input",
                    placeholder: "z. B. 3"
                  }, null, 512), [
                    [
                      _vModelText,
                      courseAssignForm.value.notifyCount,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _hoisted_173
              ]),
              (courseAssignError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_174, _toDisplayString(courseAssignError.value), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_175, [
                (courseAssignModalMode.value === 'edit')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-danger",
                      onClick: doDeleteAssignment
                    }, "Löschen"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (courseAssignModalVisible.value = false))
                }, "Abbrechen"),
                _createElementVNode("button", {
                  class: "btn-primary",
                  disabled: courseAssignSaving.value || !courseAssignForm.value.targetId || (courseAssignForm.value.kind === 'instruction' ? !courseAssignForm.value.instructionId : (!courseAssignModalCourse.value && !courseAssignForm.value.courseId)),
                  onClick: saveAssignment
                }, _toDisplayString(courseAssignSaving.value ? 'Wird gespeichert…' : 'Speichern'), 9, _hoisted_176)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'instructions')
        ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
            _createVNode(InstructionAdmin, { onAssign: openCreateAssignmentForInstruction })
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'courses')
        ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
            _createElementVNode("div", _hoisted_179, [
              _hoisted_180,
              _createElementVNode("div", _hoisted_181, [
                _withDirectives(_createElementVNode("select", {
                  class: "year-select",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((selectYear).value = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(courseYears), (year) => {
                    return (_openBlock(), _createElementBlock("option", { key: year }, _toDisplayString(year), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectYear.value]
                ]),
                _createElementVNode("button", {
                  class: "btn-ghost",
                  onClick: _cache[31] || (_cache[31] = ($event: any) => (printOrgOverviewAll()))
                }, " Gesamtübersicht ")
              ])
            ]),
            _createElementVNode("div", _hoisted_182, [
              _createElementVNode("table", _hoisted_183, [
                _hoisted_184,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(users), (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user.userId
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_185, _toDisplayString(displayName(user) || user.userName), 1),
                        _createElementVNode("div", _hoisted_186, _toDisplayString(user.email || user.userName), 1)
                      ]),
                      _createElementVNode("td", null, [
                        (completedCoursesForUser(user.userId).length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "count-chip",
                              onClick: ($event: any) => (openCompletionsPopup(user, completedCoursesForUser(user.userId), 'Kurse'))
                            }, _toDisplayString(completedCoursesForUser(user.userId).length) + " abgeschlossen", 9, _hoisted_187))
                          : (_openBlock(), _createElementBlock("span", _hoisted_188, "—"))
                      ]),
                      _createElementVNode("td", null, [
                        (completedInstructionsForUser(user.userId).length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "count-chip",
                              onClick: ($event: any) => (openCompletionsPopup(user, completedInstructionsForUser(user.userId), 'Unterweisungen'))
                            }, _toDisplayString(completedInstructionsForUser(user.userId).length) + " abgeschlossen", 9, _hoisted_189))
                          : (_openBlock(), _createElementBlock("span", _hoisted_190, "—"))
                      ]),
                      _createElementVNode("td", _hoisted_191, [
                        _createElementVNode("button", {
                          class: "btn-ghost small",
                          disabled: !userHasAnyCompletion(user.userId),
                          onClick: ($event: any) => (printUserCombined(user))
                        }, "Sammel-Zertifikat", 8, _hoisted_192)
                      ])
                    ]))
                  }), 128)),
                  (_unref(users).length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_193, _hoisted_195))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'reminders')
        ? (_openBlock(), _createElementBlock("div", _hoisted_196, [
            _createElementVNode("div", _hoisted_197, [
              _hoisted_198,
              _createElementVNode("div", _hoisted_199, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((reminderSearch).value = $event)),
                  type: "search",
                  class: "reminder-search",
                  placeholder: "Empfänger oder Kurs suchen"
                }, null, 512), [
                  [_vModelText, reminderSearch.value]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "year-select",
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((reminderStatusFilter).value = $event))
                }, _hoisted_204, 512), [
                  [_vModelSelect, reminderStatusFilter.value]
                ])
              ])
            ]),
            _hoisted_205,
            _createElementVNode("div", _hoisted_206, [
              _createElementVNode("table", _hoisted_207, [
                _hoisted_208,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredReminderLogs), (r) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: r.reminderId
                    }, [
                      _createElementVNode("td", null, _toDisplayString(fmtDateTime(r.sentAt)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_209, _toDisplayString(r.userName || r.email), 1),
                        _createElementVNode("div", _hoisted_210, _toDisplayString(r.email), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(reminderKindLabel(r.kind)), 1),
                      _createElementVNode("td", null, _toDisplayString(r.itemTitle), 1),
                      _createElementVNode("td", null, _toDisplayString(fmtIsoDate(r.deadline)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", reminderBadgeClass(r.status)])
                        }, _toDisplayString(reminderStatusLabel(r.status)), 3)
                      ])
                    ]))
                  }), 128)),
                  (_unref(reminderLogsLoading) && _unref(filteredReminderLogs).length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_211, _hoisted_213))
                    : (_unref(filteredReminderLogs).length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_214, _hoisted_216))
                      : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'settings')
        ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
            _createElementVNode("form", {
              class: "settings-form",
              onSubmit: _withModifiers(saveSettings, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_219, [
                _createElementVNode("div", _hoisted_220, [
                  _hoisted_221,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((settingsForm.value.name) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "Name der Einrichtung",
                    required: ""
                  }, null, 512), [
                    [_vModelText, settingsForm.value.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_222, [
                  _hoisted_223,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((settingsForm.value.street) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "Musterstraße"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.street]
                  ])
                ]),
                _createElementVNode("div", _hoisted_224, [
                  _hoisted_225,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((settingsForm.value.streetNo) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "12"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.streetNo]
                  ])
                ]),
                _createElementVNode("div", _hoisted_226, [
                  _hoisted_227,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((settingsForm.value.addressAddition) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "optional"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.addressAddition]
                  ])
                ]),
                _createElementVNode("div", _hoisted_228, [
                  _hoisted_229,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((settingsForm.value.postalCode) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "12345"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.postalCode]
                  ])
                ]),
                _createElementVNode("div", _hoisted_230, [
                  _hoisted_231,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((settingsForm.value.city) = $event)),
                    type: "text",
                    class: "settings-input",
                    placeholder: "Musterstadt"
                  }, null, 512), [
                    [_vModelText, settingsForm.value.city]
                  ])
                ]),
                _createElementVNode("div", _hoisted_232, [
                  _hoisted_233,
                  _createElementVNode("div", _hoisted_234, [
                    _createElementVNode("div", _hoisted_235, [
                      (logoPreview.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: logoPreview.value,
                            class: "logo-preview",
                            alt: "Logo"
                          }, null, 8, _hoisted_236))
                        : (_openBlock(), _createElementBlock("div", _hoisted_237, _hoisted_240))
                    ]),
                    _createElementVNode("div", _hoisted_241, [
                      _hoisted_242,
                      _createElementVNode("label", {
                        class: _normalizeClass(["btn-ghost logo-upload-btn", { uploading: logoUploading.value }])
                      }, [
                        _createTextVNode(_toDisplayString(logoUploading.value ? 'Wird hochgeladen…' : 'Logo auswählen') + " ", 1),
                        _createElementVNode("input", {
                          type: "file",
                          accept: "image/png,image/jpeg,image/svg+xml",
                          class: "sr-only",
                          disabled: logoUploading.value,
                          onChange: handleLogoUpload
                        }, null, 40, _hoisted_243)
                      ], 2),
                      (logoError.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_244, _toDisplayString(logoError.value), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_245, [
                (settingsSaved.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_246, "Gespeichert"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn-ghost",
                  disabled: settingsSaving.value
                }, _toDisplayString(settingsSaving.value ? 'Wird gespeichert…' : 'Speichern'), 9, _hoisted_247)
              ])
            ], 40, _hoisted_218)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(InviteUser, {
      groups: groups.value,
      onUserCreated: onUserCreated
    }, null, 8, ["groups"]),
    _createVNode(DeleteUser, { userId: selectedUserUserId.value }, null, 8, ["userId"]),
    (editUserModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "group-modal-backdrop",
          onClick: _cache[46] || (_cache[46] = _withModifiers(($event: any) => (editUserModalVisible.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_248, [
            _createElementVNode("div", _hoisted_249, [
              _hoisted_250,
              _createElementVNode("button", {
                class: "group-modal-close",
                type: "button",
                "aria-label": "Schließen",
                onClick: _cache[40] || (_cache[40] = ($event: any) => (editUserModalVisible.value = false))
              }, "×")
            ]),
            _createElementVNode("div", _hoisted_251, [
              _createElementVNode("div", _hoisted_252, [
                _hoisted_253,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((editUserForm.value.firstName) = $event)),
                  type: "text",
                  class: "settings-input",
                  placeholder: "Vorname",
                  onKeyup: _withKeys(saveEditUser, ["enter"]),
                  autofocus: ""
                }, null, 40, _hoisted_254), [
                  [_vModelText, editUserForm.value.firstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_255, [
                _hoisted_256,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((editUserForm.value.lastName) = $event)),
                  type: "text",
                  class: "settings-input",
                  placeholder: "Nachname",
                  onKeyup: _withKeys(saveEditUser, ["enter"])
                }, null, 40, _hoisted_257), [
                  [_vModelText, editUserForm.value.lastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_258, [
                _hoisted_259,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((editUserForm.value.email) = $event)),
                  type: "email",
                  autocomplete: "off",
                  class: "settings-input",
                  placeholder: "name@einrichtung.de",
                  onKeyup: _withKeys(saveEditUser, ["enter"])
                }, null, 40, _hoisted_260), [
                  [_vModelText, editUserForm.value.email]
                ]),
                _hoisted_261
              ]),
              (editUserTarget.value?.type !== 'OWNER')
                ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                    _createElementVNode("label", _hoisted_263, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((editUserForm.value.isAdmin) = $event)),
                        class: "edit-admin-check"
                      }, null, 512), [
                        [_vModelCheckbox, editUserForm.value.isAdmin]
                      ]),
                      _hoisted_264
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (editUserError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_265, _toDisplayString(editUserError.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_266, [
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[45] || (_cache[45] = ($event: any) => (editUserModalVisible.value = false))
              }, "Abbrechen"),
              _createElementVNode("button", {
                class: "btn-primary",
                disabled: editUserSaving.value,
                onClick: saveEditUser
              }, _toDisplayString(editUserSaving.value ? 'Wird gespeichert…' : 'Speichern'), 9, _hoisted_267)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (removeGroupConfirm.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "group-modal-backdrop",
          onClick: _cache[48] || (_cache[48] = _withModifiers(($event: any) => (removeGroupConfirm.value = null), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_268, [
            _hoisted_269,
            _createElementVNode("p", _hoisted_270, [
              _createTextVNode(" Soll der Mitarbeiter wirklich aus der Gruppe "),
              _createElementVNode("strong", null, _toDisplayString(groups.value.find(g => g.groupId === removeGroupConfirm.value?.groupId)?.name), 1),
              _createTextVNode(" entfernt werden? ")
            ]),
            _createElementVNode("div", _hoisted_271, [
              _createElementVNode("button", {
                class: "btn-ghost",
                onClick: _cache[47] || (_cache[47] = ($event: any) => (removeGroupConfirm.value = null))
              }, "Abbrechen"),
              _createElementVNode("button", {
                class: "btn-danger",
                onClick: confirmRemoveFromGroup
              }, "Entfernen")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})